module.exports = __webpack_public_path__ + "img/languageSetting.79200888.svg";